import { format } from "date-fns";

export const formatDateToUI = (date: string | number | Date): string => {
  const localDate = new Date(date);

  return format(localDate, "dd/MM/yyyy hh:mm a");
};
